<ngx-smart-modal #modal identifier="{{modalId}}" customClass="no-padding nsm-dialog-animation-fade nsm-centered" (onAnyCloseEventFinished)="onCloseModal()"
    (onOpen)="onOpenModal()" [dismissable]="false">

    <div class="modal-content">
        <div class="modal-header">
            <h4 class="title">{{title}}</h4>
            <p class="category">{{description}}</p>
        </div>
        <div class="modal-body">
            <ng-content></ng-content>
        </div>
        <div class="modal-footer">
            <div class="row" *ngIf="showButtons" >
                <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12">
                    <div class="form-group form-button">                        
                        <button class="btn btn-fill btn-success" (click)="onBtnAceptarClick()" [disabled]="buttonOkDisabled">Aceptar</button>
                        <button class="btn btn-fill btn-danger" type="button" (click)="onBtnCancelarClick()">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ngx-smart-modal>